import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './LicencesLoading.Config.Styles';

const licencesListTitleConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.listTitle),
  },
];

const searchBarConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.searchBar),
  },
];

const licencesUsageTitleConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.usageTitle),
  },
];

const licencesUsageSubtitleConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.usageSubtitle),
  },
];

const licenceUsageCardLoadingConfig = [
  {
    left: setLoadingConfigObject('circle', 1, null, styles.licencesCardBodyItemCircle),
    main: [
      setLoadingConfigObject('square', 1, null, styles.licencesUsageCardBodyItemSquare),
      setLoadingConfigObject('square', 1, null, styles.licencesUsageCardBodyItemSecondSquare),
    ],
  },
];
const licenceCardLoadingConfig = [
  {
    left: setLoadingConfigObject('circle', 1, null, styles.licencesCardBodyItemCircle),
    main: [
      'column',
      setLoadingConfigObject('square', 1, null, styles.licencesCardBodyItemSquare),
      setLoadingConfigObject('square', 1, null, styles.licencesCardBodyItemMiddleSquare),
      setLoadingConfigObject('square', 1, null, styles.licencesCardBodyItemLastSquare),
    ],
  },
];

const tabsLoadingConfig = [
  {
    main: [
      'row',
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle),
    ],
  },
];

export {
  licencesUsageTitleConfig,
  licencesUsageSubtitleConfig,
  licenceUsageCardLoadingConfig,
  licenceCardLoadingConfig,
  shimmerPlaceholderConfig,
  tabsLoadingConfig,
  licencesListTitleConfig,
  searchBarConfig,
};
